(() => {
  'use strict';
  const root = document.getElementById('nb-earbuds');
  if (!root || root.dataset.handle !== 'paekole-ai-translation-earbuds' || root.dataset.productId !== '10933164703903') return;
  const form = root.querySelector('#nb-purchase');
  const quantity = root.querySelector('#nb-quantity');
  const buttons = [...root.querySelectorAll('[data-purchase]')];
  const status = root.querySelector('#nb-status');
  const variant = Number(root.dataset.variantId);
  const product = Number(root.dataset.productId);
  const originals = buttons.map(button => button.innerHTML);
  const storageKey = 'nb-earbuds-pending';
  let busy = false;
  let pending = null;
  try { pending = JSON.parse(sessionStorage.getItem(storageKey) || 'null'); } catch (_) {}
  const available = root.dataset.available === 'true' && Number.isSafeInteger(variant) && variant > 0;
  function message(text) { status.textContent = text; status.hidden = !text; }
  function lock(on, label = 'ADDING…') {
    busy = on;
    quantity.disabled = on;
    buttons.forEach((button, index) => {
      button.disabled = on || !available;
      button.setAttribute('aria-busy', String(on));
      button.innerHTML = on ? label : originals[index];
    });
  }
  function savePending(value) {
    pending = value;
    try { value ? sessionStorage.setItem(storageKey, JSON.stringify(value)) : sessionStorage.removeItem(storageKey); } catch (_) {}
  }
  function localUrl(path) {
    const url = new URL(path, window.location.origin);
    if (url.origin !== window.location.origin) throw new Error('Purchase service unavailable.');
    return url;
  }
  async function jsonRequest(path, options = {}) {
    const response = await fetch(localUrl(path), {
      credentials: 'same-origin', cache: 'no-store', ...options,
      headers: { Accept: 'application/json', 'Content-Type': 'application/json', ...options.headers },
      signal: AbortSignal.timeout(20000)
    });
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data.description || data.message || 'Unable to add this product. Please try again.');
      error.definite = response.status >= 400 && response.status < 500;
      throw error;
    }
    return data;
  }
  function matches(line, request) {
    return Number(line.variant_id || line.id) === variant && Number(line.product_id) === product &&
      Number(line.quantity) === request.quantity && line.properties?._nb_request === request.id;
  }
  async function recover(request) {
    const cart = await jsonRequest(root.dataset.cartUrl.replace(/\/$/, '') + '.js');
    return Array.isArray(cart.items) && cart.items.some(line => matches(line, request));
  }
  function checkout(request) {
    savePending(null);
    lock(true, 'OPENING CHECKOUT…');
    message('Added ' + request.quantity + (request.quantity === 1 ? ' pair.' : ' pairs.') + ' Opening secure checkout…');
    // Shopify's native permalink preloads only this variant and the chosen quantity.
    // It avoids cart drawers and checkout containing unrelated storefront cart items.
    const checkoutUrl = localUrl(root.dataset.cartUrl.replace(/\/$/, '') + '/' + variant + ':' + request.quantity);
    checkoutUrl.searchParams.set('ref', 'nb-ai-earbuds');
    window.location.assign(checkoutUrl.href);
  }
  lock(false);
  if (!available) message('This product is currently unavailable.');
  form.addEventListener('submit', async event => {
    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy || !available) return;
    const count = Number(quantity.value);
    if (!Number.isInteger(count) || count < 1 || count > 99) {
      message('Choose a whole-number quantity from 1 to 99.'); quantity.focus(); return;
    }
    lock(true); message('');
    let request = pending;
    try {
      if (request) {
        if (request.variant !== variant || !(await recover(request))) {
          message('The previous add request could not be confirmed. Refresh to check again before adding more.');
          lock(true, 'CHECK REQUEST'); return;
        }
        checkout(request); return;
      }
      request = {id: crypto.randomUUID(), variant, quantity: count};
      savePending(request);
      const added = await jsonRequest(root.dataset.addUrl.replace(/\/$/, '') + '.js', {
        method: 'POST', body: JSON.stringify({items: [{id: variant, quantity: count, properties: {_nb_request: request.id}}]})
      });
      if (!Array.isArray(added.items) || added.items.length !== 1 || !matches(added.items[0], request)) {
        throw new Error('The cart response did not confirm this product and quantity.');
      }
      checkout(request);
    } catch (error) {
      if (error.definite) {
        savePending(null); lock(false); message(error.message); return;
      }
      try {
        if (request && await recover(request)) { checkout(request); return; }
      } catch (_) {}
      lock(true, 'CHECK REQUEST');
      message('We could not confirm the add request. Refresh to check its status; no duplicate request will be sent.');
    }
  }, true);
  window.addEventListener('pageshow', () => { lock(false); message(available ? '' : 'This product is currently unavailable.'); });
})();
